import { render, staticRenderFns } from "./demo-crm-account-confirmation-flow.vue?vue&type=template&id=9b07a050&scoped=true&"
import script from "./demo-crm-account-confirmation-flow.vue?vue&type=script&lang=js&"
export * from "./demo-crm-account-confirmation-flow.vue?vue&type=script&lang=js&"
import style0 from "./demo-crm-account-confirmation-flow.vue?vue&type=style&index=0&id=9b07a050&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b07a050",
  null
  
)

export default component.exports